<!-- 订单详情 -->
<template>
  <div :class="['indentDetail', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <common-title
      titleName="订单详情"
      :bcColor="'#F9F9F9'"
      :zIndex="1000"
      :routerJumpParam="routerJumpParam"
    ></common-title>
    <IndentHeader :orderDetail="orderDetail" :countDown="countDown" />
    <IndentInfo :orderDetail="orderDetail" :memberPackage="memberPackage" />
    <!-- <IndentEarnest/> -->
    <IndentPice :orderDetail="orderDetail" />
    <IndentFooter :orderDetail="orderDetail" />
    <!-- <IndentBalance/> -->
    <Footer v-if="orderDetail.status === 1" :orderDetail="orderDetail" @showDiaLog="showDiaLog" />
    <DiaLog
      ref="logShow"
      :logType="'detailIndent'"
      :orderID="orderID"
      @clearDetailList="clearDetailList"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reqOrderDetail } from '@/api/personal/orderController';
import { invalidTimeCount } from '@/utils/tools';
import CommonTitle from '@/components/header/CommonTitle.vue';
import IndentHeader from './components/indentHeader.vue';
import IndentInfo from './components/indentInfo.vue';
// import IndentEarnest from './components/indentEarnest.vue';
import IndentPice from './components/indentPice.vue';
import IndentFooter from './components/indentFooter.vue';
// import IndentBalance from './components/indentBalance.vue';
import Footer from './components/footer.vue';
import DiaLog from '../components/diaLog.vue';

export default {
  data() {
    return {
      orderDetail: {},
      orderStatus: '', // 订单状态
      countDown: '', // 倒计时
      orderID: '', // 取消订单id
      routerJumpParam: {}, // 右上角返回按钮参数
      source: Number(this.$route.query.source),
      memberPackage: false,
    };
  },

  components: {
    CommonTitle,
    IndentHeader,
    IndentInfo,
    // IndentEarnest,
    IndentPice,
    IndentFooter,
    // IndentBalance,
    Footer,
    DiaLog,
  },

  computed: {
    ...mapState(['userInfo']),
  },

  mounted() {},

  created() {
    this.getOrderDetail();
  },

  methods: {
    async getOrderDetail() {
      try {
        const res = await reqOrderDetail(this.$route.query.orderNo);
        if (res.code === 0) {
          this.orderDetail = res.data;
          // console.log(this.orderDetail,'订单');
          // if(res.data.status ==3 && res.data.haveLogistics ==false) {
          //   this.showButton = false //订单无物流是不展示添加地址
          // }
          // if(res.data.status==3&& res.data.haveLogistics ==true&&res.data.orderUserAddressVO !=null){
          //   this.showButton = false //订单有物流有地址不要在订单详情页展示修改地址
          // }
          let param = {};
          if (this.orderDetail.packageProductList.length > 0) {
            param = { combinationId: this.orderDetail.packageProductList[0].packageId };
          } else {
            param = { productId: this.orderDetail.productVOList[0].productId };
          }

          Object.assign(this.routerJumpParam, param);
          this.orderDetail.productVOList.forEach((e) => {
            e.skuNewName = [];
            if (JSON.parse(e.skuName)) {
              JSON.parse(e.skuName).forEach((list) => {
                e.skuNewName.push(list.value);
              });
            }
          });
          this.orderDetail.packageProductList.forEach((m) => {
            this.memberPackage = m.packageType === 2;
            m.orderProductVOList.forEach((e) => {
              e.skuNewName = [];
              if (JSON.parse(e.skuName)) {
                JSON.parse(e.skuName).forEach((list) => {
                  e.skuNewName.push(list.value);
                });
              }
            });
          });
          if (res.data.status === 1) {
            // 倒计时
            this.transferTimeList(res.data.payTimeout, res.data.status);
          }
        } else {
          this.$toast(res.msg);
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    transferTimeList(payTimeout, status) {
      const that = this;
      let timeOut = payTimeout;
      if (status === 1) {
        this.timer = setInterval(() => {
          if (timeOut === 0) {
            this.getOrderDetail();
            clearInterval(this.timer);
          }
          timeOut -= 1;
          that.countDown = invalidTimeCount(timeOut);
        }, 1000);
      }
    },
    // footer组件调用弹出弹窗
    showDiaLog(id) {
      this.orderID = id;
      this.$refs.logShow.show = true;
    },
    clearDetailList() {
      this.getOrderDetail();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === 'myIndent') {
        sessionStorage.setItem('routerJumpParam', 'myIndent');
      }
      // eslint-disable-next-line no-param-reassign
      vm.routerJumpParam.from = from;
    });
  },
};
</script>

<style lang="scss" scoped>
.indentDetail {
  // position: relative;
  width: 100%;
  height: 100%;
  // margin-bottom: 100px;
  padding: 100px 36px 150px;
  background: #f9f9f9ff;
  user-select: none;
  &.inApp {
    padding-top: 33px;
    padding-bottom: 0;
  }
  &-body {
    position: relative;
    bottom: 55px;
    width: 100%;
    min-height: 100%;
    padding: 0 36px;
    &-content {
      width: 100%;
      // height: 200px;
      // background: $bgWhite;
    }
  }
}
</style>
